var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('img',{staticClass:"header-bg-image",attrs:{"src":require("@/assets/header_image.png"),"alt":"Header Image"}}),_c('div',{staticClass:"header-content"},[_c('div',{staticClass:"left"},[_c('h1',[_vm._v("中国企业数据资产"),_c('br'),_vm._v("入表名录")])])])])
}]

export { render, staticRenderFns }